export default __webpack_public_path__ + "static/SRF 0100S - Product Specifications & Technical Data-6ba23831803324fd73f9dbc53032d53e.pdf";